import React from 'react'
import { Column } from '@sencha/ext-modern'

import { handleItemContextMenu } from '../contextmenu'
import { getBindedProps } from './utilities'

const render = (column, that, forViewModel, checkGridData) => {
	const { _flow, key, title, width, bind, icon, ui = 'action', disabled, onFinish, hidden, text, param, /* handler,  */...rest } = column
	const bindedProps = getBindedProps({ bind, icon, ui, disabled, hidden, text }, that, key, forViewModel);

	return (<Column width={width} align="center" key={key} text={title} {...rest}
		cell={{
			tools: [
				{
					type: 'menu', ...bindedProps,
					handler: (tree, { grid, record, event }) => {
						handleItemContextMenu([column], grid, record, event, that, checkGridData)
						// const { id } = record.data
						// checkGridData([record.data.id])
						// 	.then(r => r && getFlow({ flow: _flow, id, param, onFinish: onFinish || refreshPage,/* onClose, onFlowFinished */ }))
						// 	.then(({ acts }) => {
						// 		const buttons = acts.map(({ config }) => (config.flowHandler = config.handler, delete config.handler, config))
						// 		handleItemContextMenu(buttons, grid, record, event, that)
						// 	})
					}
				}
			]
		}}
		menuDisabled
	/>)
}

export default render